import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { rembursment, status } from '../../utils/Helpers';
import _ from "lodash";
import moment from "moment";
import { updateReimbursementStatus, getMemberReimbursementDetails } from '../../services';
import { motion, AnimatePresence } from 'framer-motion';
import { Activity, ClipboardList, Clock, FileText, Info } from "lucide-react";
import MemberDetailsModal from '../../components/SharedComponets/MemberDetailsModal';
const AdminRembursmentList = ({
    allRequests,
    setAllRequests,
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [rejectMessage, setRejectMessage] = useState('');
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isApprovedLoading, setApprovedLoading] = useState(false);
    const [amount, setAmount] = useState('');
    const [comment, setComment] = useState('');
    const [isCommentPopup, setIsCommentPopup] = useState(false);
    const [selectedComment, setSelectedComment] = useState('');
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [memberDetails, setMemberDetails] = useState(null);
    const [loadingMembers, setLoadingMembers] = useState({});
    const [error, setError] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedContent, setSelectedContent] = useState('');

    const toggleDropdown = (index, event) => {
        if (isDropdownOpen === index) {
            setIsDropdownOpen(null);
        } else {
            const button = event.currentTarget;
            const rect = button.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX - 100 // Adjust this value to position the dropdown properly
            });
            setIsDropdownOpen(index);
        }
    };

    // Add click outside handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDropdownOpen !== null && !event.target.closest('.status-dropdown')) {
                setIsDropdownOpen(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);

    const handleStatusChange = async (requestId, newStatus, index, message = '', invoiceAmount = '') => {
        try {
            setApprovedLoading(true);

            const requestsData = {
                Id: requestId,
                RequestStatus: newStatus,
                Comment: message,
                InvoiceAmount: parseFloat(invoiceAmount), // Ensure this is correctly parsed
            };

            console.log('Updating request:', requestId, 'with status:', newStatus, 'and amount:', invoiceAmount);

            await updateReimbursementStatus(requestsData);

            setAllRequests((prevState) => ({
                ...prevState,
                RequestList: prevState.RequestList.map((request) =>
                    request.Id === requestId
                        ? { ...request, RequestStatus: newStatus, Comment: message, InvoiceAmount: invoiceAmount }
                        : request
                ),
            }));

            console.log(`Status changed to ${newStatus} for request ${requestId} with message: ${message}`);
            setIsDropdownOpen(null);
            setIsRejectModalOpen(false);
        } catch (error) {
            console.error('Error updating reimbursement status:', error);
        } finally {
            setApprovedLoading(false);
        }
    };

    const handleRejectSubmit = () => {
        if (currentIndex !== null && allRequests?.RequestList?.[currentIndex]) {
            const request = allRequests.RequestList[currentIndex];
            if (request?.Id) {
                setIsLoading(true); // Start loader
                console.log('Rejecting request:', request.Id, 'with amount:', request.InvoiceAmount);
                handleStatusChange(request.Id, 2, currentIndex, rejectMessage, request.InvoiceAmount) // Pass InvoiceAmount here
                    .finally(() => setIsLoading(false)); // Stop loader after process
            } else {
                console.error('Request or Request.Id is undefined');
            }
        } else {
            console.error('Invalid currentIndex or allRequests structure');
        }
    };

    const handleRejectClick = (index) => {
        setCurrentIndex(index);
        setIsRejectModalOpen(true);
    };

    const handleApproveSubmit = () => {
        if (selectedRequest) {
            handleStatusChange(selectedRequest.Id, 3, null, comment, amount);
            setIsModalOpen(false);
        }
    };

    const toggleCommentPopup = (comment = '') => {
        setSelectedComment(comment);
        setIsCommentPopup(!isCommentPopup);
    };

    const formatCreatedAt = (date) => moment(date).format("DD/MM/YYYY, h:mm A");

    const handleMemberDetailsClick = async (memberId) => {
        try {
            setLoadingMembers(prev => ({ ...prev, [memberId]: true }));
            setError(null);
            const response = await getMemberReimbursementDetails(memberId);
            console.log('API Response:', response);
            if (response && response.Result) {
                setMemberDetails(response.Result);
                setIsDetailsModalOpen(true);
            } else {
                setError('No data received from the server');
            }
        } catch (error) {
            console.error('Error fetching member details:', error);
            setError('Failed to fetch member details. Please try again.');
        } finally {
            setLoadingMembers(prev => ({ ...prev, [memberId]: false }));
        }
    };

    const handleOpenPopup = (content) => {
        // Add natural line breaks to long text
        const formattedContent = content
            .split(/\s+/)
            .reduce((lines, word, i) => {
                if (i % 8 === 0) {
                    lines.push([word]);
                } else {
                    lines[lines.length - 1].push(word);
                }
                return lines;
            }, [])
            .map(line => line.join(' '))
            .join('\n');

        setSelectedContent(formattedContent);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

    const hasRequests = !_.isEmpty(allRequests) && allRequests?.TotalCount > 0;

    return (
        <div>
            {/* Total Cards Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 px-5">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-gradient-to-br from-blue-50 to-white dark:from-blue-900/30 dark:to-gray-800 rounded-xl shadow-lg p-6 border border-blue-100 dark:border-blue-800/50 hover:shadow-xl transition-all duration-300"
                >
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-blue-600 dark:text-blue-400 mb-1">{rembursment[1]} Total</p>
                            <p className="text-2xl font-bold text-gray-900 dark:text-white">
                                Rs {allRequests?.Totals?.requestType1Total || '0.00'}
                            </p>
                        </div>
                        <div className="p-3 bg-blue-100 dark:bg-blue-900/50 rounded-full">
                            <svg className="w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="bg-gradient-to-br from-green-50 to-white dark:from-green-900/30 dark:to-gray-800 rounded-xl shadow-lg p-6 border border-green-100 dark:border-green-800/50 hover:shadow-xl transition-all duration-300"
                >
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-green-600 dark:text-green-400 mb-1">{rembursment[2]} Total</p>
                            <p className="text-2xl font-bold text-gray-900 dark:text-white">
                                Rs {allRequests?.Totals?.requestType2Total || '0.00'}
                            </p>
                        </div>
                        <div className="p-3 bg-green-100 dark:bg-green-900/50 rounded-full">
                            <svg className="w-6 h-6 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                            </svg>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="bg-gradient-to-br from-purple-50 to-white dark:from-purple-900/30 dark:to-gray-800 rounded-xl shadow-lg p-6 border border-purple-100 dark:border-purple-800/50 hover:shadow-xl transition-all duration-300"
                >
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-purple-600 dark:text-purple-400 mb-1">{rembursment[3]} Total</p>
                            <p className="text-2xl font-bold text-gray-900 dark:text-white">
                                Rs {allRequests?.Totals?.requestType3Total || '0.00'}
                            </p>
                        </div>
                        <div className="p-3 bg-purple-100 dark:bg-purple-900/50 rounded-full">
                            <svg className="w-6 h-6 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="bg-gradient-to-br from-yellow-50 to-white dark:from-yellow-900/30 dark:to-gray-800 rounded-xl shadow-lg p-6 border border-yellow-100 dark:border-yellow-800/50 hover:shadow-xl transition-all duration-300"
                >
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-yellow-600 dark:text-yellow-400 mb-1">Total Utility Payment</p>
                            <p className="text-2xl font-bold text-gray-900 dark:text-white">
                                Rs {allRequests?.Totals?.totalCompanyPayment || '0.00'}
                            </p>
                        </div>
                        <div className="p-3 bg-yellow-100 dark:bg-yellow-900/50 rounded-full">
                            <svg className="w-6 h-6 text-yellow-600 dark:text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* List Header + Desktop Cards */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4 }}
                className="space-y-3 px-5 mt-6"
            >
                {/* Header row */}
                <div className="flex items-center justify-between mb-1 px-1">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                        <Activity className="w-5 h-5 text-blue-500" />
                        All Reimbursement Requests
                    </h3>
                    <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
                        Total: {allRequests?.TotalCount || 0}
                    </span>
                </div>

                {/* Desktop List — Card per row */}
                <div className="hidden md:block bg-white dark:bg-gray-900/40 rounded-2xl border border-gray-100 dark:border-blue-gray-900 shadow-sm">
                    {/* Column Headers */}
                    <div className="grid grid-cols-[1.4fr_1.15fr_0.9fr_1.2fr_0.95fr_0.95fr_1fr_1.15fr] gap-6 px-6 py-3 border-b border-gray-100 dark:border-gray-800/60 bg-gray-50/60 dark:bg-gray-800/40">
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest pr-2">
                            Member
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest pl-12">
                            Date
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest pl-3">
                            Type
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                            Detail
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                            Amount
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                            PDF File
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest pl-5">
                            Status
                        </div>
                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest pl-4">
                            Created At
                        </div>
                    </div>

                    {/* Rows */}
                    <div className="p-3 space-y-2">
                        {hasRequests ? (
                            <AnimatePresence mode="popLayout">
                                {allRequests?.RequestList?.map((request, index) => {
                                    const cfg = status[request.RequestStatus]
                                        ? {
                                            label: status[request.RequestStatus],
                                            color:
                                                request.RequestStatus === 1
                                                    ? "amber"
                                                    : request.RequestStatus === 2
                                                        ? "red"
                                                        : "green",
                                        }
                                        : { label: "Pending", color: "amber" };

                                    const colorMap = {
                                        amber: {
                                            badge: "bg-amber-500/10 text-amber-500 border-amber-500/40",
                                            dot: "bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]",
                                        },
                                        green: {
                                            badge: "bg-green-500/10 text-green-500 border-green-500/40",
                                            dot: "bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]",
                                        },
                                        red: {
                                            badge: "bg-red-500/10 text-red-500 border-red-500/40",
                                            dot: "bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.5)]",
                                        },
                                    };

                                    const colors = colorMap[cfg.color] || colorMap.amber;

                                    return (
                                        <motion.div
                                            key={request.Id || index}
                                            initial={{ opacity: 0, y: 8 }}
                                            animate={{ opacity: 1, y: 0, transition: { delay: index * 0.03 } }}
                                            exit={{ opacity: 0, scale: 0.97 }}
                                            className="grid grid-cols-[1.4fr_1.15fr_0.9fr_1.2fr_0.95fr_0.95fr_1fr_1.15fr] gap-6 items-center px-6 py-4 bg-gray-50/50 dark:bg-gray-800/30 hover:bg-blue-50/30 dark:hover:bg-blue-900/10 rounded-xl border border-gray-100 dark:border-gray-800/40 transition-colors"
                                        >
                                            {/* Member */}
                                            <div className="min-w-0 pr-3">
                                                <button
                                                    type="button"
                                                    onClick={() => handleMemberDetailsClick(request.MemberId)}
                                                    className="flex items-center gap-2 px-0 py-0 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-200 group"
                                                    disabled={loadingMembers[request.MemberId]}
                                                >
                                                    <span className="text-[14px] font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors truncate">
                                                        {request.MemberName}
                                                    </span>
                                                    <span className="p-1.5 rounded-full bg-blue-50 dark:bg-blue-900/30 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40 transition-colors">
                                                        {loadingMembers[request.MemberId] ? (
                                                            <svg className="animate-spin h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                            </svg>
                                                        ) : (
                                                            <svg className="w-4 h-4 text-blue-500 group-hover:text-blue-600 dark:group-hover:text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                            </svg>
                                                        )}
                                                    </span>
                                                </button>
                                            </div>

                                            {/* Date */}
                                            <div className="text-[14px] font-light text-gray-700 dark:text-gray-300 pl-10 min-w-0">
                                                {request.Date}
                                            </div>

                                            {/* Type */}
                                            <div className="flex items-center gap-2 min-w-0">
                                                <div className="p-1.5 bg-blue-50 dark:bg-blue-500/10 rounded-lg flex-shrink-0">
                                                    <ClipboardList className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400" />
                                                </div>
                                                <div className="text-[14px] font-light text-gray-700 dark:text-gray-300 truncate">
                                                    {rembursment[request.RequestType]}
                                                </div>
                                            </div>

                                            {/* Detail */}
                                            <div className="min-w-0">
                                                {request.RequestDetail && request.RequestDetail.length > 30 ? (
                                                    <button
                                                        onClick={() => handleOpenPopup(request.RequestDetail)}
                                                        className="text-[13px] font-light text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                                                    >
                                                        View Details →
                                                    </button>
                                                ) : (
                                                    <span className="text-[13px] font-light text-gray-700 dark:text-gray-300">
                                                        {request.RequestDetail || "—"}
                                                    </span>
                                                )}
                                            </div>

                                            {/* Amount */}
                                            <div className="text-[14px] font-semibold text-gray-900 dark:text-white">
                                                Rs {request.InvoiceAmount}
                                            </div>

                                            {/* PDF */}
                                            <div className="min-w-0 flex items-center gap-1.5">
                                                {request.InvoicePath ? (
                                                    <Link
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        to={`https://portalbackend.gentrickstaffing.com${request.InvoicePath}`}
                                                        className="flex items-center gap-1.5 text-[13px] font-light text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                                                    >
                                                        <FileText className="w-3.5 h-3.5" />
                                                        View PDF
                                                    </Link>
                                                ) : (
                                                    <span className="text-[13px] font-light text-gray-400">—</span>
                                                )}
                                            </div>

                                            {/* Status */}
                                            <div className="flex items-center justify-end gap-1.5">
                                                {request.RequestStatus === 2 && request.Comment && (
                                                    <button
                                                        onClick={() => toggleCommentPopup(request.Comment)}
                                                        className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                                        title="View Comment"
                                                    >
                                                        <Info className="w-3.5 h-3.5 text-blue-500" />
                                                    </button>
                                                )}
                                                <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-[11px] font-bold border uppercase tracking-[0.08em] whitespace-nowrap ${colors.badge}`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full me-1.5 ${colors.dot}`} />
                                                    {cfg.label}
                                                </span>
                                                {request.RequestStatus === 1 && (
                                                    <button
                                                        onClick={(e) => toggleDropdown(index, e)}
                                                        className="status-dropdown p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                                    >
                                                        <svg className="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>

                                            {/* Created At */}
                                            <div className="text-[12px] font-light pl-5 text-gray-400 dark:text-gray-500 uppercase tracking-tight">
                                                {formatCreatedAt(request.CreatedAt)}
                                            </div>
                                        </motion.div>
                                    );
                                })}
                            </AnimatePresence>
                        ) : (
                            <div className="py-16 flex flex-col items-center justify-center">
                                <div className="p-4 bg-gray-100 dark:bg-gray-800 rounded-full mb-4">
                                    <Info className="w-8 h-8 text-gray-400" />
                                </div>
                                <p className="text-gray-500 dark:text-gray-400 font-medium text-base">
                                    No Reimbursement found.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Mobile Cards */}
                <div className="flex flex-col gap-3 md:hidden">
                    {hasRequests ? (
                        <AnimatePresence mode="popLayout">
                            {allRequests?.RequestList?.map((request, index) => {
                                const cfg = status[request.RequestStatus]
                                    ? {
                                        label: status[request.RequestStatus],
                                        color:
                                            request.RequestStatus === 1
                                                ? "amber"
                                                : request.RequestStatus === 2
                                                    ? "red"
                                                    : "green",
                                    }
                                    : { label: "Pending", color: "amber" };

                                const colorMap = {
                                    amber: {
                                        badge: "bg-amber-500/10 text-amber-500 border-amber-500/40",
                                        dot: "bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]",
                                    },
                                    green: {
                                        badge: "bg-green-500/10 text-green-500 border-green-500/40",
                                        dot: "bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]",
                                    },
                                    red: {
                                        badge: "bg-red-500/10 text-red-500 border-red-500/40",
                                        dot: "bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.5)]",
                                    },
                                };

                                const colors = colorMap[cfg.color] || colorMap.amber;

                                return (
                                    <motion.div
                                        key={request.Id || index}
                                        initial={{ opacity: 0, x: -20 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: index * 0.05 }}
                                        className="bg-white dark:bg-gray-900/40 border border-gray-100 dark:border-blue-gray-900 rounded-2xl p-5 shadow-sm space-y-4"
                                    >
                                        <div className="flex items-center justify-between">
                                            <button
                                                type="button"
                                                onClick={() => handleMemberDetailsClick(request.MemberId)}
                                                className="flex flex-col items-start"
                                            >
                                                <span className="text-sm font-bold text-gray-900 dark:text-gray-100">
                                                    {request.MemberName}
                                                </span>
                                                <span className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">
                                                    {rembursment[request.RequestType]}
                                                </span>
                                            </button>
                                            <div className="flex items-center gap-1.5">
                                                {request.RequestStatus === 2 && request.Comment && (
                                                    <button
                                                        onClick={() => toggleCommentPopup(request.Comment)}
                                                        className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                                        title="View Comment"
                                                    >
                                                        <Info className="w-3.5 h-3.5 text-blue-500" />
                                                    </button>
                                                )}
                                                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold border uppercase ${colors.badge}`}>
                                                    <span className={`w-1 h-1 rounded-full me-1.5 ${colors.dot}`} />
                                                    {cfg.label}
                                                </span>
                                                {request.RequestStatus === 1 && (
                                                    <button
                                                        onClick={(e) => toggleDropdown(index, e)}
                                                        className="status-dropdown p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                                    >
                                                        <svg className="w-3.5 h-3.5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-3 py-3 border-y border-gray-50 dark:border-gray-800/50">
                                            <div>
                                                <div className="text-[9px] text-gray-400 uppercase font-black tracking-widest mb-1">
                                                    Date
                                                </div>
                                                <div className="text-[11px] font-medium text-gray-700 dark:text-gray-300">
                                                    {request.Date}
                                                </div>
                                            </div>
                                            <div>
                                                <div className="text-[9px] text-gray-400 uppercase font-black tracking-widest mb-1">
                                                    Amount
                                                </div>
                                                <div className="text-[11px] font-bold text-gray-900 dark:text-white">
                                                    Rs {request.InvoiceAmount}
                                                </div>
                                            </div>
                                        </div>

                                        {request.RequestDetail && (
                                            <div className="pt-3 border-b border-gray-50 dark:border-gray-800/50 pb-3">
                                                <button
                                                    onClick={() => handleOpenPopup(request.RequestDetail)}
                                                    className="text-[11px] font-bold text-blue-600 dark:text-blue-400 hover:text-blue-700 transition-colors"
                                                >
                                                    View Details →
                                                </button>
                                            </div>
                                        )}

                                        <div className="flex items-center justify-between pt-1">
                                            <div className="text-[10px] text-gray-400 uppercase">
                                                <Clock className="w-3 h-3 inline me-1" />
                                                {formatCreatedAt(request.CreatedAt)}
                                            </div>
                                            {request.InvoicePath && (
                                                <Link
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    to={`https://portalbackend.gentrickstaffing.com${request.InvoicePath}`}
                                                    className="flex items-center gap-1.5 text-[11px] font-bold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                                                >
                                                    <FileText className="w-3.5 h-3.5" />
                                                    View PDF
                                                </Link>
                                            )}
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </AnimatePresence>
                    ) : (
                        <div className="bg-white dark:bg-gray-900/40 rounded-2xl border border-gray-100 dark:border-blue-gray-900 p-10 text-center">
                            <Info className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                            <p className="text-gray-500 dark:text-gray-400 font-medium">No Reimbursement found.</p>
                        </div>
                    )}
                </div>
            </motion.div>

            {isRejectModalOpen && (
                <div className="fixed inset-0 bg-white dark:bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center">
                    <div className="bg-white dark:bg-gray-900 p-5 rounded-lg w-96 shadow-lg">
                        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">Note:</h2>
                        <textarea
                            className="w-full p-2 border rounded mb-4 bg-gray-100 dark:bg-gray-800 dark:border-gray-700 text-gray-900 dark:text-gray-100"
                            placeholder="Enter rejection reason..."
                            value={rejectMessage}
                            onChange={(e) => setRejectMessage(e.target.value)}
                        />
                        <div className="flex justify-end">
                            <button
                                className="bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 px-4 py-2 rounded mr-2"
                                onClick={() => setIsRejectModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-red-700 text-white px-4 py-2 rounded flex items-center justify-center"
                                onClick={handleRejectSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <svg
                                        aria-hidden="true"
                                        className="w-6 h-6 animate-spin text-white"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentFill"
                                        />
                                    </svg>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isModalOpen && selectedRequest && (
                <div className="fixed inset-0 bg-white dark:bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center">
                    <div className="bg-white dark:bg-gray-900 p-5 rounded-lg w-96 shadow-lg">
                        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">Approve Request</h2>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Member Name</label>
                            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">{selectedRequest.MemberName}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Amount</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded bg-gray-100 dark:bg-gray-800 dark:border-gray-700 text-gray-900 dark:text-gray-100"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Date</label>
                            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">{selectedRequest.Date}</p>
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Comment</label>
                            <textarea
                                className="w-full pp-2 border rounded bg-gray-100 dark:bg-gray-800 dark:border-gray-700 text-gray-900 dark:text-gray-100"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </div>
                        <div className="flex justify-end">
                            <button
                                className="bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 px-4 py-2 rounded mr-2"
                                onClick={() => setIsModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-green-700 text-white px-4 py-2 rounded"
                                onClick={handleApproveSubmit}
                            >
                                Approve
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isCommentPopup && (
                <div className="fixed inset-0 bg-white dark:bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center">
                    <div className="bg-white dark:bg-gray-900 p-8 pt-8 rounded-lg w-96 shadow-lg">
                        <div className="flex items-center justify-between mb-8">
                            <motion.h3
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.3 }}
                                className="text-2xl font-bold bg-black dark:bg-white bg-clip-text text-transparent"
                            >
                                Comment Details
                            </motion.h3>
                            <motion.button
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: 0.3 }}
                                onClick={toggleCommentPopup}
                                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-all duration-200 hover:scale-110 hover:rotate-90"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18 18 6M6 6l12 12"
                                    />
                                </svg>
                            </motion.button>
                        </div>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4 }}
                            className="mt-4 p-6 bg-gradient-to-br from-gray-50 to-white dark:from-gray-800 dark:to-gray-900 rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-inner"
                        >
                            <p className="text-gray-800 dark:text-gray-200 leading-relaxed text-lg">
                                {selectedComment}
                            </p>
                        </motion.div>
                    </div>
                </div>
            )}

            {/* Member Details Modal */}
            {isDetailsModalOpen && (
                <MemberDetailsModal
                    isOpen={isDetailsModalOpen}
                    onClose={() => {
                        setIsDetailsModalOpen(false);
                        setMemberDetails(null);
                        setError(null);
                    }}
                    memberDetails={memberDetails}
                    error={error}
                />
            )}


            {/* Dropdown Menu rendered at root level */}
            {isDropdownOpen !== null && (
                <div
                    className="fixed z-50 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 status-dropdown"
                    style={{
                        top: `${dropdownPosition.top}px`,
                        left: `${dropdownPosition.left}px`
                    }}
                >
                    <div className="py-1" role="menu" aria-orientation="vertical">
                        <button
                            onClick={() => {
                                handleStatusChange(allRequests.RequestList[isDropdownOpen].Id, 1, isDropdownOpen);
                                setIsDropdownOpen(null);
                            }}
                            className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                            role="menuitem"
                        >
                            Pending
                        </button>
                        <button
                            onClick={() => {
                                setSelectedRequest(allRequests.RequestList[isDropdownOpen]);
                                setAmount(allRequests.RequestList[isDropdownOpen].InvoiceAmount);
                                setIsModalOpen(true);
                                setIsDropdownOpen(null);
                            }}
                            className="w-full text-left px-4 py-2 text-sm text-green-600 dark:text-green-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                            role="menuitem"
                        >
                            Approved
                        </button>
                        <button
                            onClick={() => {
                                handleRejectClick(isDropdownOpen);
                                setIsDropdownOpen(null);
                            }}
                            className="w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                            role="menuitem"
                        >
                            Rejected
                        </button>
                    </div>
                </div>
            )}

            {isPopupOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl max-w-lg w-full">
                        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                                Request Details
                            </h3>
                            <button
                                onClick={handleClosePopup}
                                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors"
                            >
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="p-6">
                            <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4">
                                <p className="text-gray-700 dark:text-gray-300 text-base leading-7 break-words" style={{ wordBreak: 'break-word', maxWidth: '100%' }}>
                                    {selectedContent}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminRembursmentList;